<div class="shift-types-table-content">
    <form [formGroup]="staffForm">
        <div formArrayName="staffArray" class="table-container" [ngClass]="{'fullWidth': !showAddAnother, 'confirmModal': shownInApp}"    [ngStyle]="{height: shownInApp ? '' : '350px'}">
            <mat-table #staffTable [dataSource]="staffForm.get('staffArray')?.controls" automation-id="table-manual-add">
                <ng-container matColumnDef="firstname">
                    <mat-header-cell *matHeaderCellDef class="type-col">
                        First Name *
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index; let row" [formGroupName]="i">
                        <input (input)="onInput(row)" maxlength="15"
                            *ngIf="(editableStaffId === row?.value?.id) || !row?.value?.id; else notNewRow" matInput
                            placeholder="First Name" formControlName="firstname" [attr.automation-id]="'firstname-' + i"
                            class="input-field">
                        <ng-template #notNewRow>
                            {{ element?.value?.firstname }}
                        </ng-template>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="lastname">
                    <mat-header-cell *matHeaderCellDef class="type-col">
                        Last Name *
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index;let row" [formGroupName]="i">
                        <input (input)="onInput(row)" maxlength="15"
                            *ngIf="(editableStaffId === row?.value?.id) || !row?.value?.id; else displayLastName"
                            matInput placeholder="Last Name" formControlName="lastname" class="input-field"
                            [attr.automation-id]="'lastname-' + i">
                        <ng-template #displayLastName>
                            <span>{{
                                element?.value?.lastname }}</span>
                        </ng-template>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="phonenumber">
                    <mat-header-cell *matHeaderCellDef class="type-col">
                        Mobile Number *
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index;let row" [formGroupName]="i">
                        <input (input)="onInput(row)" [mask]="'(000) 000-0000'"
                            *ngIf="(editableStaffId === row?.value?.id) || !row?.value?.id; else displayNumber" matInput
                            placeholder="Mobile Phone" formControlName="phonenumber" class="input-field"
                            [attr.automation-id]="'displayName-' + i">
                        <ng-template #displayNumber>
                            <span>{{
                                element?.value?.phonenumber | mask: '(000) 000-0000'}}</span>
                        </ng-template>
                    </mat-cell>
                </ng-container>


                <ng-container matColumnDef="stafftypeid">
                    <mat-header-cell *matHeaderCellDef class="type-col">
                        Staff Type *
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index;let row" [formGroupName]="i">
                        <app-custom-autocomplete
                            *ngIf="(editableStaffId === row?.value?.id) || !row?.value?.id; else displayStaffType"
                            (valueChange)="onInput(row)" [items]="staffTypes" formControlName="stafftypeid">
                        </app-custom-autocomplete>
                        <ng-template #displayStaffType>
                            <span>{{
                                showStaffTypeAbbreviation(element?.value?.stafftypeid ) }}</span>
                        </ng-template>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="action">
                    <mat-header-cell *matHeaderCellDef class="last-header-cell"></mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index; let row" class="edit-btn-cell"
                        [attr.automation-id]="'edit-shift-type-button-' + i">
                        <button mat-button matTooltipClass="add-shift" matTooltip="Edit" matTooltipPosition="above"
                            class="edit" *ngIf="row?.value?.id !==editableStaffId" automation-id="get-selected-staff-id"
                            (click)="editableMode ? '' : getEditableStaffId(row?.value)">
                            <i class="fal fa-edit"></i>
                            <span>Edit</span>
                        </button>

                        <div class="actions">
                            <button mat-button matTooltip="DELETE" matTooltipClass="add-shift"
                                matTooltipPosition="above" class="delete"
                                *ngIf="row?.value?.id === editableStaffId &&!isNewStaff && !(!showAddAnother && dataSource.data.length === 1) && canDelete"
                                automation-id="delete-staff" (click)="deleteStaff(row.value)">
                                <i class="far fa-trash-alt"></i>
                                <span>delete</span>
                            </button>
                            <button mat-button class="cancel" *ngIf="row?.value?.id === editableStaffId"
                                automation-id="cancel-update-add" (click)="cancelAction(row.value)">
                                <span>cancel</span>
                            </button>
                            <button mat-button class="save"
                                [ngClass]="{'enabled-button' : (validStaff && isNewStaff), 'enable-save' : hasBeenModified}"
                                (click)="hasBeenModified ? updateStaff(row.value) : ''" automation-id="update-staff"
                                *ngIf="row?.value?.id === editableStaffId && !isNewStaff">
                                <span>save</span>

                            </button>
                            <button mat-button class="save" type="submit"
                                [ngClass]="{'enabled-button' : (validStaff  && isNewStaff), 'enable-save' : hasBeenModified}"
                                automation-id="add-new-staff" (click)="validStaff ? addNewStaff(row) : ''"
                                *ngIf="row?.value?.id === editableStaffId && isNewStaff">
                                <span>add</span>
                            </button>
                        </div>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="addRow">
                    <mat-footer-cell *matFooterCellDef="let i = index" colspan="6">
                        <button matTooltip="Add" matTooltipClass="add-shift" matTooltipPosition="above"
                            automation-id="add-new-row" [disabled]="isNewStaff" (click)="addNewRow()"
                            class="add-another-btn">
                            <mat-icon>add_circle_outline</mat-icon>
                            Add Another
                        </button>
                    </mat-footer-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"
                    [ngClass]="{'edit-mode-table': editableMode}"></mat-header-row>

                <mat-row matTooltipClass="add-shift" (click)="editableMode ? '' : getEditableStaffId(row?.value)"
                    [matTooltip]="editableMode ? '' : 'Edit'" matTooltipPosition="above"
                    *matRowDef="let row; columns: displayedColumns;" class="row-highlight"
                    [ngClass]="{'edit-mode': row?.value?.id === editableStaffId, 'edit-mode-table': editableMode}"
                    #tableRows></mat-row>
                <div *ngIf="showAddAnother">
                    <mat-footer-row [ngClass]="{'edit-mode-table': editableMode}" *matFooterRowDef="['addRow']"
                        class="footer-highlight">
                    </mat-footer-row>
                </div>
            </mat-table>
        </div>
    </form>
</div>